import React from 'react';
import PropTypes from 'prop-types';
import { Map, Marker, TileLayer, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';
import moment from 'moment';

import 'leaflet/dist/leaflet.css';
// import Paper from '@material-ui/core/Paper'

import redMarker from '../../../assets/images/Marker/redMarker.png';
import greenMarker from '../../../assets/images/Marker/greenMarker.png';
import blueMarker from '../../../assets/images/Marker/blueMarker.png';
import { formatDistance } from 'date-fns';

const iconIn = Leaflet.icon({
  iconUrl: greenMarker,
  iconAnchor: [13.5, 41],
  popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});

const iconOut = Leaflet.icon({
  iconUrl: redMarker,
  iconAnchor: [13.5, 41],
  popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});

const iconAllowed = Leaflet.icon({
  iconUrl: blueMarker,
  iconAnchor: [13.5, 41],
  popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});

class MapMarker extends React.Component {
  constructor() {
    super();
    this.state = {
      zoom: 13,
    };
  }

  initializeDateItemForm = (item) => {
    if (item) {
      const date = item
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/');
      const hour = item.split('T')[1].split('.')[0];

      return `${date} ${hour}`;
    }
    return '';
  };

  render() {
    const { locations, center } = this.props;

    return (
      <div id="container">

        {/* height = 430 */}
        <Map
          center={center}
          zoomControl={true}
          zoom={this.state.zoom}
          style={{ height: 400, margin: '0 auto', width: '100%' }}
        >

          <TileLayer
            attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {
            locations
              ? locations.map((locationData, index) => (
                <Marker
                  position={[locationData.lat, locationData.lng]}
                  key={index}
                  icon={locationData.type === 'I' ? iconIn : (locationData.type === 'O' ? iconOut : iconAllowed)}
                  popupAnchor={[0, -41]}
                >
                  <Popup>
                    {["I", "O"].includes(locationData.type) ?
                      (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span style={{ fontSize: '1rem', marginBottom: '0.35em' }}>
                            <strong>Local do registro do ponto</strong>
                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                              <strong>Nome: </strong>
                              <span style={{ fontWeight: '400' }}>{locationData.schedule.employee.name} </span>
                            </h3>
                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                              <strong>Data: </strong>
                              <span style={{ fontWeight: '400' }}>{(moment(locationData.schedule.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy'))} </span>
                            </h3>
                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                              <strong>Hora: </strong>
                              <span style={{ fontWeight: '400' }}>{(moment(locationData.schedule.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm'))} </span>
                            </h3>
                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                              <strong>Endereço: </strong>
                              <span style={{ fontWeight: '400' }}>{locationData.schedule.timeclock.addressLocation} </span>
                            </h3>
                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                              <strong>Tipo de ponto: </strong>
                              <span style={{ fontWeight: '400' }}>{locationData.type === "I" ? 'Entrada' : 'Saída'} </span>
                            </h3>
                          </span>
                        </div>
                      )
                      : <div> <span style={{ fontSize: '1rem', marginBottom: '0.35em' }}>
                        <strong>Local permitido para registro</strong>
                        <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                              <strong>Local: </strong>
                              <span style={{ fontWeight: '400' }}>{locationData.description} </span>
                            </h3>
                        <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                          <strong>Distancia do ponto registrado: </strong>
                          {locationData.distanceFromTc < 1000 ?
                            (<span style={{ fontWeight: '400' }}>{(locationData.distanceFromTc).toFixed(0)} metros</span>)
                            : <span style={{ fontWeight: '400' }}>{(locationData.distanceFromTc / 1000).toFixed(0)} quilômetros</span>
                          }
                        </h3>
                        <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                          <strong>Raio tolerância: </strong>
                          <span style={{ fontWeight: '400' }}>{(locationData.range).toFixed(0)} metros</span>
                        </h3>
                      </span></div>
                    }
                  </Popup>

                </Marker>
              ))
              : null}
        </Map>
      </div>
    );
  }
}

MapMarker.propTypes = {
  locations: PropTypes.array,
  center: PropTypes.array,
};

MapMarker.defaultProps = {
  locations: [],
  center: [-3.71839, -38.5434],
};

export default MapMarker;
